import { Component, EventEmitter, inject, Output } from '@angular/core';
import { ThemeService } from '../services/theme';

@Component({
  selector: 'app-timed-out',
  imports: [],
  templateUrl: './timed-out.html',
  styleUrl: './timed-out.scss',
})
export class TimedOut {
  @Output() navClick = new EventEmitter<void>();

  private readonly themeService = inject(ThemeService);

  get arrowPath() {
    return this.themeService.isLight() ? '/arrow-light.svg' : '/arrow.svg';
  }

  // HELPERS
  onChildClick() {
    this.navClick.emit();
  }
}
